// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2c7YB","log":"ModalInventoryLogs_log__3UCc5","date":"ModalInventoryLogs_date__LNjEt","userName":"ModalInventoryLogs_userName__1fI3G"};